import styled from "styled-components";


const AppWrapper = styled.div`
background: linear-gradient(217deg, rgba(255,0,0,.8), rgba(255,0,0,0) 70.71%),
            linear-gradient(127deg, rgba(0,255,0,.8), rgba(0,255,0,0) 70.71%),
            linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%);
background-position: center;
background-size: cover;
height: 100%;
min-height: 100vh;
background-attachment: fixed;
width: 100vw;
display: flex;
justify-content: center;
align-items: center;
`
export default AppWrapper